(function ($) {
  let closeMenuTimeout;
  let activeMenu = null;

  function clearCloseMenuTimeout() {
    if (closeMenuTimeout) {
      window.clearTimeout(closeMenuTimeout);
      closeMenuTimeout = null;
    }
  }

  function deactivateCustomMenus() {
    clearCloseMenuTimeout();
    activeMenu = null;
    $('.header .mega-menu--custom').removeClass('is-active').removeAttr('open');
  }

  function activateCustomMenu($menu) {
    clearCloseMenuTimeout();
    $('.header .mega-menu--custom').not($menu).removeClass('is-active').removeAttr('open');
    $menu.addClass('is-active').attr('open', 'open');
    activeMenu = $menu.get(0);
  }

  function scheduleDeactivateCustomMenus() {
    clearCloseMenuTimeout();
    closeMenuTimeout = window.setTimeout(() => {
      deactivateCustomMenus();
    }, 180);
  }

  function isWithinCustomMenuArea(currentTarget, relatedTarget) {
    return !!(relatedTarget && currentTarget && currentTarget.contains(relatedTarget));
  }

  $('.header .mega-menu__content li').hover(function () {
    if ($(this).closest('.mega-menu--custom').length) {
      return;
    }

    const image = $(this).find('> .category-data .category-image').html();
    const text = $(this).find('> .category-data .category-text').html();

    if (image || text) {
      $('.header .mega-menu__content .category-data-view .category-image').html(image);
      $('.header .mega-menu__content .category-data-view .category-text').html(text);
    }
  });

  $(document).on('mouseenter', '.header__menu-custom-parent', function () {
    const $menu = $(this).find('.mega-menu--custom').first();
    if ($menu.length) {
      activateCustomMenu($menu);
    }
  });

  $(document).on('mouseleave', '.header__menu-custom-parent', function (event) {
    if (isWithinCustomMenuArea(this, event.relatedTarget)) {
      return;
    }

    scheduleDeactivateCustomMenus();
  });

  $(document).on('mouseenter', '.header .mega-menu__content--custom', function () {
    clearCloseMenuTimeout();
  });

  $(document).on('mouseleave', '.header .mega-menu__content--custom', function (event) {
    if (isWithinCustomMenuArea(this, event.relatedTarget)) {
      return;
    }

    scheduleDeactivateCustomMenus();
  });

  $(document).on('mouseenter', '.header .header__inline-menu > .list-menu > li:not(.header__menu-custom-parent)', function () {
    if (activeMenu) {
      deactivateCustomMenus();
    }
  });

  $(document).on('click', '.header .mega-menu--custom > summary', function (event) {
    event.preventDefault();
    const $menu = $(this).closest('.mega-menu--custom');

    if ($menu.hasClass('is-active')) {
      deactivateCustomMenus();
    } else {
      activateCustomMenu($menu);
    }
  });

  $(document).on('keyup', function (event) {
    if (event.key === 'Escape') {
      deactivateCustomMenus();
    }
  });

  document.addEventListener(
    'toggle',
    function (event) {
      const menu = event.target;

      if (!(menu instanceof HTMLDetailsElement) || !menu.matches('.header .mega-menu--custom')) {
        return;
      }

      const $menu = $(menu);
      const isOpen = menu.hasAttribute('open');

      if (isOpen) {
        $menu.addClass('is-active');
        activeMenu = menu;
      } else {
        $menu.removeClass('is-active');

        if (activeMenu === menu) {
          activeMenu = null;
        }
      }
    },
    true
  );
})(jQuery);
